import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "src/pages/Home";
import Register from "src/pages/Register";
import Navigation from "src/pages/Navigation";
import Verify from "src/pages/Verify";
import { NAV_MENU_ITEMS, ROUTE_MAP } from "src/library/constants";
import { NavMenuEnum, RoutesEnum, RoutingAnchorEnum } from "src/library/types/types";
import { useHackathonContext } from "src/library/store/GlobalStateProvider";

export const generateRouteMap = () => {
  NAV_MENU_ITEMS.forEach((element: any) => {
    let route = "";
    switch (element) {
      // case NavMenuEnum.Home:
      //   route = RoutingAnchorEnum.Home;
      //   break;
      case NavMenuEnum.Event:
        route = RoutingAnchorEnum.Event;
        break;
      case NavMenuEnum.ChallengesPrizes:
        route = RoutingAnchorEnum.ChallengesPrizes;
        break;
      case NavMenuEnum.Guests:
        route = RoutingAnchorEnum.Guests;
        break;
      case NavMenuEnum.Partners:
        route = RoutingAnchorEnum.Partners;
        break;
      case NavMenuEnum.Faq:
        route = RoutingAnchorEnum.Faq;
        break;
      case NavMenuEnum.Contact:
        route = RoutingAnchorEnum.Contact;
        break;
      default:
        break;
    }
    ROUTE_MAP.set(element, route);
  });
};

export const getScrollToRoute = (section: string) => {
  return `/${ROUTE_MAP.get(section)}`;
};

export const scrollWithOffset = (el: HTMLElement) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = -50;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};

function AppRouter() {
  const { state } = useHackathonContext();
  const theme = useTheme();
  const showMobileMenu = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Routes>
      <Route path={RoutesEnum.Home} element={<Home />} />
      <Route
        path={RoutesEnum.Register}
        element={
          state.registrationsAvailable ? (
            <Register />
          ) : (
            <Navigate replace to={RoutesEnum.Home} />
          )
        }
      />
      <Route
        path={RoutesEnum.Nav}
        element={
          showMobileMenu ? <Navigation /> : <Navigate replace to={RoutesEnum.Home} />
        }
      />
      <Route path={RoutesEnum.Verify} element={<Verify />} />
      {/* REDIRECT 404 ROUTES BACK HOME */}
      <Route path="*" element={<Navigate replace to={RoutesEnum.Home} />} />
    </Routes>
  );
}

export default AppRouter;
